import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  box: {
    padding: '44px 16px 26px 16px',
    boxSizing: 'border-box',
  },
  text2: {
    fontWeight: 100,
  },
  container: {
    marginBottom: 20,
  },
  icon: {
    marginRight: '8px',
    marginBottom: 0,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
  },
}));

const ProfileTitle = ({ ...props }) => {
  const { mobile, subtitle, title, icon } = props;
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Box
        display="flex"
        justifyContent={mobile ? 'center' : 'flex-start'}
        alignItems="center"
        marginBottom="14px"
      >
        {mobile && <div className={classes.icon}>{icon} </div>}
        <Typography
          className={classes.title}
          data-cy={title.toString().split(' ').join('')}
        >
          {title}
        </Typography>
      </Box>
      <Typography
        align={mobile ? 'center' : 'left'}
        variant="h5"
        className={classes.text2}
      >
        {subtitle}
      </Typography>
    </Box>
  );
};

ProfileTitle.propTypes = {
  mobile: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  icon: PropTypes.element,
};

export default ProfileTitle;
